module.exports = __webpack_public_path__ + "static/img/industryBanner-m.7090579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industryBanner-m.png
// module id = PNNg
// module chunks = 0